export enum InforStatusLabelEnum {
  INVOICED = "Invoiced",
  PAID_IN_FULL = "Paid In Full",
  NEEDS_DELIVERY_SCHEDULED = "Needs Delivery Scheduled",
  READY_FOR_PICKUP = "Ready For Pickup",
  DELIVERY_SCHEDULED = "Delivery Scheduled",
  RETURN_IN_PROGRESS = "Return in Progress",
}
